 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button @click="goAdd">新增</el-button>
        </div>
        <!-- 表单开始 -->

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">模糊搜索：</span>
                <el-input style="width: 100%;" v-model="search_data" placeholder="姓名/电话模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">所属公司：</span>
                <el-select
                    clearable
                    @change="changeCompany" v-model="company_id" placeholder="请选择所属公司"  style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">

            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">所属部门：</span>
                <el-select
                    clearable
                    @change="changeDepartment" v-model="department_id" placeholder="请选择状态"  style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allDepartment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">&ensp;&ensp;所属组：</span>
                <el-select
                    clearable
                    v-model="group_id" placeholder="请选择所属组"  style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allGroup"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <div class="docker_buttons" v-if="role_id == 1 || role_id == 21" style="float: right;margin: 10px 0px 8px 0px;">
            <el-button type="primary" @click="exportServiceData">导出服务管理数据</el-button>
        </div>
        <!-- 表单结束 -->
        <el-table :data="tableData" border style="width: 100%">
            <!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="no" width="60" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" width="110" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" width="110" label="电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="company_name"  label="所属公司" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="department_name" label="所属部门" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="group_name" label="所属组" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="70" label="状态" align="center" label-class-name="label">
                <template scope="scope">
                    <span v-if="scope.row.status == 1">启用</span>
                    <span v-else>停用</span>
                </template>
            </el-table-column>
            <el-table-column prop="doctor_count" width="170" label="服务特属专家人数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_count" width="170" label="服务特属服务对象人数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="last_login_time" width="160" label="最后登录时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                prop="address"
                label="操作"
                align="center"
                label-class-name="label"
                v-slot="scope"
            >
                <el-button  @click="goDetail(scope.row)" type="text">
                    查看
                </el-button>
                <el-button  @click="goEdit(scope.row)" type="text">
                    编辑
                </el-button>
                <el-button @click="startStop(scope.row,2)"
                           v-if="scope.row.status==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button  @click="startStop(scope.row,1)"
                           v-if="scope.row.status==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button @click="resetPassword(scope.row)" type="text"
                           size="small">重置密码
                </el-button>
<!--                <el-button @click="goDel(scope.row)" type="text">-->
<!--                    删除-->
<!--                </el-button>-->
            </el-table-column>
        </el-table>
        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 25, 50, 100]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
        ></el-pagination>
        <!-- 删除确认 弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="deleteDialogVisible"
            width="20%"
            :before-close="done => done()"
            center
            top="20%"
        >
            <span style="display: block; text-align: center;">确认删除？</span>
            <span slot="footer" class="dialog-footer">
        <el-button @click="deleteData('cancel')">取消</el-button>
        <el-button type="primary" @click="deleteData('sure')">确定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {check} from "@/utils/checkData";
import {getUserInfos} from '@/utils/userInfos';
import {isMobile} from "@/api/order";

export default {
    data() {
        return {
            role_id: 0,
            child_role_id: 0,
            search_data: null,
            page: 1,
            perpage: 10,
            total: 0,
            tableData: [],
            //删除确认
            deleteDialogVisible: false,
            delete_id: '',
            company_id: '',
            department_id: '',
            group_id: '',
            allCompany: [],
            allDepartment: [],
            allGroup: [],
            button_position: 'absolute',
        };
    },
    mounted() {
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
        }
        // 获取运营人员列表
        this.getList();
        this.getCompany()
        localStorage.setItem('prev_page', 'operate_list')
    },
    created() {
        if (isMobile()) {
            this.button_position = 'static'
        }
    },
    methods: {
        // 获取所有服务团队成员
        getList() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'operateUserList',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
                params: {
                    search_data: this.search_data,
                    company_id: this.company_id,
                    department_id: this.department_id,
                    group_id: this.group_id,
                },
                user_account: this.user_account,
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 序号
                    res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                }
                //
                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;
            });
        },
        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },
        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },

        // 跳转编辑页
        goEdit(data) {
            this.$router.push({
                name: "operatorUserEdit",
                params: {
                    id: data.id,
                    mobile: data.mobile,
                    user_name: data.user_name,
                    company_id: data.company_id,
                    department_id: data.department_id,
                    group_id: data.group_id,
                    status: data.status,
                    introduction: data.introduction,
                    user_avatar: data.user_avatar,
                    // posistion: data.posistion,
                    // user_title: data.user_title,
                }
            });
        },
        // 跳转详情页
        goDetail(data) {
            this.$router.push({
                name: "operatorUserDetail",
                params: {
                    id: data.id,
                }
            });
        },
        // 重置按钮
        resetForm() {
            this.search_data = "";
            this.company_id = "";
            this.department_id = "";
            this.group_id = "";
            this.getList();
        },
        // 搜索
        search() {
            this.page = 1;
            this.getList();
        },
        startStop(data, status) {
            let message = null;
            if (status == '1') {
                message = `确定启用服务专员：${data.user_name}？`;
            }
            if (status == '2') {
                message = `确定停用服务专员：${data.user_name}？`;
            }
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'startStopOperation',
                    params: {
                        id: data.id,
                        status: status
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '修改成功',
                        duration: 1500,
                    });
                    this.getList();
                });
            }).catch(() => {
            });
        },
        // 重置密码
        resetPassword(data) {
            this.$confirm(`确定重置 "${data.user_name}" 的密码吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'resetPawssword',
                    params: {
                        id: data.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '重置成功',
                        duration: 1500,
                    });
                });
            }).catch(() => {
            });
        },
        // 添加
        goAdd() {
            this.$router.push({name: "operatorUserAdd", params: {}});
        },

        getCompany() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'createCompanyDeparmentParams',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompany = res.data.data.all_company;

            });

        },
        // 获取公司下的运营组
        changeCompany() {
            this.allCompanyDeparment=[];
            this.department_id = '';
            this.group_id = '';
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyDeparment',
                params: {
                    status: 1,
                    company_id: this.company_id
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                this.allDepartment = res.data.data;
            });

        },
        // 获取运营组
        changeDepartment() {
            this.group_id = '';
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyGroup',
                params: {
                    company_id: this.company_id,
                    department_id: this.department_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroup = res.data.data;
            });
        },
        // 获取还未分配服务专员的特属专家
        async changeGroup(getOperateDoctor = 0) {
            let _that = this
            this.allCompanyDeparment=[];
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllDoctor',
                params: {
                    status: 1,
                    company_id: this.company_id,
                    department_id: this.department_id,
                    group_id: this.group_id,
                }
            };

            await this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                this.allDoctors = res.data.data;

                if (getOperateDoctor) {
                    _that.getOperateDoctor();
                }
            });
        },
        // 导出服务管理数据
        exportServiceData() {
            this.group_id = '';
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'exportServiceData',
                params: {
                    search_data: this.search_data,
                    company_id: this.company_id,
                    department_id: this.department_id,
                    group_id: this.group_id,
                },
                user_account: this.user_account,
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.downloadPdf(env.IMG_URL_PREFIX + res.data.data.file_url, res.data.data.file_name)
            });
        },
        downloadPdf(url, fileName){
            var x = new XMLHttpRequest();
            x.open("GET", url, true);
            x.responseType = 'blob';
            x.onload=function(e) {
                var url = window.URL.createObjectURL(x.response)
                var a = document.createElement('a');
                a.href = url
                a.download = fileName;
                a.click()
            }
            x.send();

        },
        //
    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.inputs .el-input{
    width: 100%;
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
.inputs .el-input {width: 100% !important;}
</style>
